module.exports = __webpack_public_path__ + "static/media/indexMobile.4724503c.jpg";